export interface ParsedHashRoute {
  cleanHash: string
  path: string
  rest: string[]
  query: Record<string, string>
}

export const parseHashRoute = (hashValue: string): ParsedHashRoute => {
  const rawHash = typeof hashValue === 'string' ? hashValue : ''
  const withoutMarker = rawHash.startsWith('#') ? rawHash.slice(1) : rawHash
  const [pathPart, queryPart = ''] = withoutMarker.split('?')
  const cleanHash = pathPart.startsWith('/') ? pathPart.slice(1) : pathPart
  const [path, ...rest] = cleanHash.split('/').filter(Boolean)
  const query: Record<string, string> = {}

  if (queryPart) {
    const searchParams = new URLSearchParams(queryPart)
    searchParams.forEach((value, key) => {
      if (!key) {
        return
      }
      query[key] = value
    })
  }

  return {
    cleanHash,
    path: path || '',
    rest,
    query
  }
}
